/* CHANGELOG (assets/spbox-header.js)
   v1.1 — 2026-06-12: created. Hide-on-scroll/reveal nav behavior,
          live nav-bottom offset (--spbxNavBottom) for the cart/menu
          drawers, overlay/Esc close on non-index templates. */
/* SPBOX nav bar behavior: hide on scroll down, reveal on scroll up.
   Adds .spbx-nav-hidden / .spbx-nav-scrolled to .main-header; styling
   lives in spbox-header.css. Always reveals near the top, while the
   menu/search drawers are open, or when focus enters the header. */
(function () {
  function init() {
    var mh = document.querySelector('.main-header');
    if (!mh) return;

    var lastY = window.scrollY || 0;
    var ticking = false;
    var REVEAL_AT = 96; /* always visible above this */
    var THRESH = 6;     /* ignore micro scroll jitter */

    /* expose the nav's live bottom edge — the cart drawer (spbox-cart.css)
       starts right beneath it */
    function setNavOffset() {
      var bottom = Math.max(0, Math.round(mh.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--spbxNavBottom', bottom + 'px');
    }

    function apply() {
      ticking = false;
      var y = window.scrollY || 0;
      var overlayOpen =
        document.body.classList.contains('open-menu') ||
        document.body.classList.contains('open-search') ||
        document.body.classList.contains('o-cartBox');

      mh.classList.toggle('spbx-nav-scrolled', y > 24);

      if (overlayOpen || y <= REVEAL_AT) {
        mh.classList.remove('spbx-nav-hidden');
      } else if (y > lastY + THRESH) {
        mh.classList.add('spbx-nav-hidden');
      } else if (y < lastY - THRESH) {
        mh.classList.remove('spbx-nav-hidden');
      }
      lastY = y;
      setNavOffset();
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(apply);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    /* drawer open/close toggles body classes — re-evaluate */
    new MutationObserver(apply).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
    /* keyboard users tabbing into the header must always see it */
    mh.addEventListener('focusin', function () {
      mh.classList.remove('spbx-nav-hidden');
    });
    /* keep the offset fresh while the bar/marquee animate and on resize */
    mh.addEventListener('transitionend', setNavOffset);
    window.addEventListener('resize', setNavOffset);

    /* overlay tap / Escape close the mobile menu on non-index templates
       (the index header script already handles both, plus scroll-lock) */
    if (!document.body.classList.contains('t-index')) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('.spb-mobnav-overlay')) {
          document.body.classList.remove('open-menu');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') document.body.classList.remove('open-menu');
      });
    }
    apply();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
